import { useState } from 'react'
import { API_URL_ARRAY } from 'src/consumer/constants'
import { appVersion, lastBuildDate } from 'src/consumer/services'
import {
  applyApiDebugQueryOverrides,
  clearCustomApiBaseUrl,
  clearCustomPublicApiBaseUrl,
  getApiDebugQueryConfig,
  removeApiDebugQueryOverridesFromUrl,
  resolveApiDomainConfig,
  setCustomApiBaseUrl,
  setCustomPublicApiBaseUrl,
  setStoredDefaultApiBaseUrl,
  setStoredPublicApiBaseUrl,
} from 'src/consumer/services/apiDomainConfig'

export const RestCustomServerChange = ({ floating = false }) => {
  const [password, setPassword] = useState('')
  const fixedPassword = 'devs@aumhum'
  const apiDomainConfig = resolveApiDomainConfig()
  const debugQueryConfig = getApiDebugQueryConfig()
  const hasCustomOverride = Boolean(apiDomainConfig.customApiBaseUrl)
  const hasCustomPublicOverride = Boolean(apiDomainConfig.customPublicApiBaseUrl)
  const canEdit = password === fixedPassword || hasCustomOverride || hasCustomPublicOverride

  const defaultApiSelectValue =
    apiDomainConfig.storedDefaultApiBaseUrl || apiDomainConfig.defaultApiBaseUrl || ''
  const publicApiSelectValue =
    apiDomainConfig.storedPublicApiBaseUrl || apiDomainConfig.defaultPublicApiBaseUrl || ''
  const customApiSelectValue = apiDomainConfig.customApiBaseUrl || ''
  const customPublicApiSelectValue = apiDomainConfig.customPublicApiBaseUrl || ''
  const debugPanelUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}?nebula=dust`
      : '?nebula=dust'

  const applyChangeAndReload = (callback) => {
    callback()
    window.location.reload()
  }

  return (
    <div
      style={{
        background: 'rgb(81, 67, 135)',
        color: '#fff',
        padding: '8px',
        borderRadius: floating ? '12px' : '0',
        position: floating ? 'fixed' : 'static',
        top: floating ? '16px' : 'auto',
        right: floating ? '16px' : 'auto',
        zIndex: floating ? 12000 : 'auto',
        width: floating ? 'min(420px, calc(100vw - 32px))' : '100%',
        maxHeight: floating ? 'calc(100vh - 32px)' : 'none',
        overflowY: floating ? 'auto' : 'visible',
        boxShadow: floating ? '0 18px 48px rgba(0, 0, 0, 0.3)' : 'none',
      }}
    >
      <div style={{ marginBottom: '8px', fontWeight: '700' }}>Debug Console</div>
      <div style={{ marginBottom: '4px' }}>Version: {appVersion}</div>
      <div style={{ marginBottom: '8px' }}>Build: {lastBuildDate}</div>
      <div style={{ marginBottom: '8px', fontSize: '12px', wordBreak: 'break-all' }}>
        Open this panel with: {debugPanelUrl}
      </div>
      <div style={{ marginBottom: '12px', fontSize: '12px' }}>
        URL params supported: `apiURL`, `customApiURL`, `publicApiURL`, `customPublicApiURL`
      </div>
      <div style={{ marginBottom: '12px' }}>
        PIN:{' '}
        <input
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ border: '1px solid #000', borderRadius: '4px' }}
        />
      </div>
      <div style={{ marginBottom: '8px' }}>
        Active API: {apiDomainConfig.effectiveApiBaseUrl} ({apiDomainConfig.apiSource})
      </div>
      <div style={{ marginBottom: '8px' }}>
        Active Public API: {apiDomainConfig.effectivePublicApiBaseUrl} (
        {apiDomainConfig.publicApiSource})
      </div>
      <div style={{ marginBottom: '8px' }}>
        Built-in API fallback: {apiDomainConfig.defaultApiBaseUrl}
      </div>
      <div style={{ marginBottom: '12px' }}>
        Built-in Public API fallback: {apiDomainConfig.defaultPublicApiBaseUrl}
      </div>
      {apiDomainConfig.invalidEntries.length > 0 && (
        <div style={{ marginBottom: '12px', color: '#ffd1d1' }}>
          Ignoring invalid stored URLs:
          {apiDomainConfig.invalidEntries.map((entry) => (
            <div key={entry.key}>
              {entry.key}: {entry.value}
            </div>
          ))}
        </div>
      )}
      {(debugQueryConfig.hasRequestedOverrides || debugQueryConfig.invalidEntries.length > 0) && (
        <div
          style={{
            marginBottom: '12px',
            padding: '8px',
            border: '1px solid rgba(255,255,255,0.35)',
            borderRadius: '8px',
            background: 'rgba(255,255,255,0.08)',
          }}
        >
          <div style={{ marginBottom: '8px', fontWeight: '700' }}>URL Requested Values</div>
          {debugQueryConfig.requestedApiBaseUrl && (
            <div style={{ marginBottom: '4px' }}>
              `apiURL`: {debugQueryConfig.requestedApiBaseUrl}
            </div>
          )}
          {debugQueryConfig.requestedCustomApiBaseUrl && (
            <div style={{ marginBottom: '4px' }}>
              `customApiURL`: {debugQueryConfig.requestedCustomApiBaseUrl}
            </div>
          )}
          {debugQueryConfig.requestedPublicApiBaseUrl && (
            <div style={{ marginBottom: '4px' }}>
              `publicApiURL`: {debugQueryConfig.requestedPublicApiBaseUrl}
            </div>
          )}
          {debugQueryConfig.requestedCustomPublicApiBaseUrl && (
            <div style={{ marginBottom: '4px' }}>
              `customPublicApiURL`: {debugQueryConfig.requestedCustomPublicApiBaseUrl}
            </div>
          )}
          {debugQueryConfig.invalidEntries.length > 0 && (
            <div style={{ marginBottom: '8px', color: '#ffd1d1' }}>
              Ignoring invalid URL params:
              {debugQueryConfig.invalidEntries.map((entry) => (
                <div key={entry.key}>
                  {entry.key}: {entry.value}
                </div>
              ))}
            </div>
          )}
          {debugQueryConfig.hasRequestedOverrides && (
            <button
              style={{
                borderRadius: '8px',
                padding: '6px 12px',
                color: '#fff',
                background: '#0f766e',
                border: 'none',
              }}
              onClick={() => {
                applyChangeAndReload(() => {
                  applyApiDebugQueryOverrides()
                  removeApiDebugQueryOverridesFromUrl()
                })
              }}
            >
              Apply URL values
            </button>
          )}
        </div>
      )}
      {canEdit ? (
        <div className="d-flex flex-direction-column gap-2">
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {hasCustomOverride && (
              <div
                style={{
                  borderRadius: '16px',
                  padding: '4px 16px',
                  color: '#fff',
                  background: 'red',
                }}
              >
                Custom API override active
              </div>
            )}
            {hasCustomOverride && (
              <button
                style={{
                  borderRadius: '16px',
                  padding: '4px 16px',
                  color: '#fff',
                  background: 'green',
                }}
                onClick={() => {
                  applyChangeAndReload(() => {
                    clearCustomApiBaseUrl()
                  })
                }}
              >
                Clear custom override
              </button>
            )}
            {hasCustomPublicOverride && (
              <div
                style={{
                  borderRadius: '16px',
                  padding: '4px 16px',
                  color: '#fff',
                  background: '#d97706',
                }}
              >
                Custom public API override active
              </div>
            )}
            {hasCustomPublicOverride && (
              <button
                style={{
                  borderRadius: '16px',
                  padding: '4px 16px',
                  color: '#fff',
                  background: '#2563eb',
                }}
                onClick={() => {
                  applyChangeAndReload(() => {
                    clearCustomPublicApiBaseUrl()
                  })
                }}
              >
                Clear custom public override
              </button>
            )}
          </div>
          <div>
            Default API Server:{' '}
            <select
              style={{
                color: '#fff',
                MozAppearance: 'none',
                WebkitAppearance: 'none',
                border: '1px solid white',
              }}
              onChange={(e) => {
                const nextValue = e.target.value
                applyChangeAndReload(() => {
                  setStoredDefaultApiBaseUrl(
                    nextValue === apiDomainConfig.defaultApiBaseUrl ? null : nextValue,
                  )
                })
              }}
              value={defaultApiSelectValue}
            >
              {API_URL_ARRAY.map((item) => {
                return (
                  <option value={item?.url} key={item?.url}>
                    {item?.faceValue}
                  </option>
                )
              })}
            </select>
          </div>
          <div>
            Public API Server:{' '}
            <select
              style={{
                color: '#fff',
                MozAppearance: 'none',
                WebkitAppearance: 'none',
                border: '1px solid white',
              }}
              onChange={(e) => {
                const nextValue = e.target.value
                applyChangeAndReload(() => {
                  setStoredPublicApiBaseUrl(
                    nextValue === apiDomainConfig.defaultPublicApiBaseUrl ? null : nextValue,
                  )
                })
              }}
              value={publicApiSelectValue}
            >
              {API_URL_ARRAY.map((item) => {
                return (
                  <option value={item?.url} key={item?.url}>
                    {item?.faceValue}
                  </option>
                )
              })}
            </select>
          </div>
          <div>
            Custom API Override:{' '}
            <select
              style={{
                color: '#fff',
                MozAppearance: 'none',
                WebkitAppearance: 'none',
                border: '1px solid white',
              }}
              onChange={(e) => {
                const nextValue = e.target.value
                applyChangeAndReload(() => {
                  if (!nextValue) {
                    clearCustomApiBaseUrl()
                    return
                  }
                  setCustomApiBaseUrl(nextValue)
                })
              }}
              value={customApiSelectValue}
            >
              <option value="">Disabled</option>
              {API_URL_ARRAY.map((item) => {
                return (
                  <option value={item?.url} key={item?.url}>
                    {item?.faceValue}
                  </option>
                )
              })}
            </select>
          </div>
          <div>
            Custom Public API Override:{' '}
            <select
              style={{
                color: '#fff',
                MozAppearance: 'none',
                WebkitAppearance: 'none',
                border: '1px solid white',
              }}
              onChange={(e) => {
                const nextValue = e.target.value
                applyChangeAndReload(() => {
                  if (!nextValue) {
                    clearCustomPublicApiBaseUrl()
                    return
                  }
                  setCustomPublicApiBaseUrl(nextValue)
                })
              }}
              value={customPublicApiSelectValue}
            >
              <option value="">Disabled</option>
              {API_URL_ARRAY.map((item) => {
                return (
                  <option value={item?.url} key={item?.url}>
                    {item?.faceValue}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
